import { useSliceContext } from "../../SliceProvider"
import { formatBlockscanUrl } from "@src/lib/formatBlockscanUrl"
import { useEnsName } from "wagmi"

type Props = {
  address: `0x${string}`
  href?: string
}

const ResolvedAddress = ({ address, href }: Props) => {
  const { appChainId } = useSliceContext()
  const ensName = useEnsName({ address })
  const addressReduced = address.replace(
    address.substring(5, address.length - 3),
    `\xa0\xa0\xa0\xa0\xa0\xa0`
  )

  return (
    <a
      className="sl-highlight"
      href={href || formatBlockscanUrl(appChainId, address)}
      target="_blank"
      rel="noopener noreferrer"
    >
      {typeof ensName === "string" ? ensName : addressReduced}
    </a>
  )
}

export default ResolvedAddress
